import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=8ba1b5f2&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=8ba1b5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba1b5f2",
  null
  
)

export default component.exports